import * as Sentry from '@sentry/react'

export const captureException = Sentry.captureException
export const setUser = Sentry.setUser
export const setTag = Sentry.setTag
export const withScope = Sentry.withScope
export type User = Sentry.User

export const setSentryUser = (user: { email: string; id: string }) => {
  Sentry.setUser({
    id: user.id,
    email: user.email
  })
}
